import type { UserRole } from "@/types";

/** Owner/Manager may connect or reconnect channels (API §7 `connection:manage`). */
export function hasConnectionManage(role: UserRole): boolean {
  return role === "Owner" || role === "Manager";
}

export function hasCredentialManage(role: UserRole): boolean {
  return role === "Owner";
}

export function hasCredentialManage2Fa(role: UserRole): boolean {
  return role === "Owner" || role === "Manager";
}
